export const RECOMMENDATIONS_URL = 'recommendations'
